/**
 * 公用颜色选择组件
 * @author VenDream
 * @since 18/04/17
 */

import React from 'react';
import classnames from 'classnames';

import DropDown from 'components/dropdown';
import './color-selector.less';

import allColorImg from 'assets/images/all-color.png';

class ColorSelector extends DropDown {
  static defaultProps = {
    selected: 0,
    classname: 's-color-selector',
    onSelected: () => {},
  };

  // 渲染当前的选中项
  getSelectedItem() {
    const { items, selected } = this.props;
    const { value, text, color } = items[selected];

    const style = {
      backgroundColor: color,
    };

    const itemCls = classnames({
      'selected-item': 1,
      all: value.toUpperCase() === 'ALL',
      transparent: value === 'transparent',
    });
    const blockCls = classnames({
      'color-block': 1,
      all: value.toUpperCase() === 'ALL',
      transparent: value === 'transparent',
    });

    if (value.toUpperCase() === 'ALL') {
      style.backgroundImage = `url(${allColorImg})`;
    }

    return (
      <div className={itemCls} title={text} onClick={this.handleFold}>
        <span className={blockCls} style={style} />
      </div>
    );
  }

  // 渲染所有可选项
  getItemList() {
    const { items, selected } = this.props;
    const lis = [];

    for (const [i, item] of Object.entries(items)) {
      const cls = classnames('item', ~~i === selected ? 'selected' : '');
      const { value, text, color } = item;
      const style = { backgroundColor: color };
      const blockCls = classnames({
        'color-block': 1,
        all: value.toUpperCase() === 'ALL',
        transparent: value === 'transparent',
      });

      if (value.toUpperCase() === 'ALL') {
        style.backgroundImage = `url(${allColorImg})`;
      }

      lis.push(
        <li
          className={cls}
          key={i}
          title={text}
          onClick={this.handleSelected.bind(this, ~~i, value || text, text)}>
          <span className={blockCls} style={style} />
        </li>
      );
    }

    return (
      <ul className="item-list" ref={node => (this.list = node)}>
        {lis}
      </ul>
    );
  }
}

export default ColorSelector;
